export default {
    list2:[
        {
            img: require('@/newsData/list/2026-0121-01/01-T.png'),
            title:"2026全国新年登高健身大会广州从化分会场活动在流溪河国家森林公园成功举办",
            time:'2026年1月1日',
            detail:``,
            detail_url: require('@/newsData/list/2026-0121-01/01.pdf')
        },
        
        {
            img: require('@/newsData/list/2026-0121-02/01-T.png'),
            title:"以梅为媒，绘就山水康养新画卷——2025年广州梅花观赏季在流溪河国家森林公园盛大启幕",
            time:'2025年12月27日',
            detail:``,
            detail_url: require('@/newsData/list/2026-0121-02/01.pdf')
        },
        
        {
            img: require('@/newsData/list/2026-0121-03/01-T.png'),
            title:"流溪河赏花攻略①｜粉色樱花海",
            time:'2025年12月27日',
            detail:``,
            detail_url: require('@/newsData/list/2026-0121-03/01.pdf')
        },  
        {
    img: require('@/newsData/list/2025-1113-03/01-T.png'),
    title:"秋日徒步不纠结！流溪湖漫步+五指山登高，两条路线承包您的浪漫时光",
    time:'时间: 2025年11月04日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1113-03/01.pdf')
},
{
    img: require('@/newsData/list/2025-1113-02/01-T.png'),
    title:"流溪河国家森林公园第二届体育文化（旅游）节助力“激情全运会 活力大湾区”徒步活动圆满举行！",
    time:'时间: 2025年10月26日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1113-02/01.pdf')
},
{
    img: require('@/newsData/list/2025-1113-01/01-T.jpg'),
    title:"广州从化“流溪烟渚”第二届赛艇季暨环湖徒步嘉年华盛大启幕！",
    time:'时间: 2025年10月19日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1113-01/01.pdf')
},


        {
    img: require('@/newsData/list/2025-1001-14/01-T.png'),
    title:"流溪河国家森林公园载誉而行",
    time:'时间: 2025年9月9日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-14/01.pdf')
},

{
    img: require('@/newsData/list/2025-1001-18/01-T.png'),
    title:"首次！“国蝶”金斑喙凤蝶现身广州流溪河国家森林公园",
    time:'时间: 2025年9月9日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-18/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-11/01-T.png'),
    title:"广州市水上运动管理中心到广州市流溪河国家森林公园开展调研",
    time:'时间: 2025年9月2日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-11/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-04/01-T.png'),
    title:"以“绿”为底绘就流溪烟渚生态文明新画卷",
    time:'时间: 2025年9月1日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-04/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-13/01-T.png'),
    title:"森林公园自然探秘精彩回顾",
    time:'时间: 2025年9月1日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-13/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-02/01-T.png'),
    title:"丰盈之境，邂逅湖蓝色的安然",
    time:'时间: 2025年8月28日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-02/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-15/01-T.png'),
    title:"流溪湖初夏限定！秤锤树挂满“小秤锤”，速来围观",
    time:'时间: 2025年7月28日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-15/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-12/01-T.png'),
    title:"广州市流溪河国家森林公园“做客”《大美南粤》慢直播",
    time:'时间: 2025年7月11日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-12/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-10/01-T.png'),
    title:"广州市从化区委副书记欧阳可员带队到流溪河林场开展调研",
    time:'时间: 2025年7月8日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-10/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-01/01-T.png'),
    title:"“戏水狂欢盛夏森活”系列活动",
    time:'时间: 2025年7月2日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-01/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-06/01-T.png'),
    title:"八项铁律淬党性 一以贯之树新风",
    time:'时间: 2025年6月26日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-06/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-17/01-T.png'),
    title:"践行垃圾分类，共享健康家园",
    time:'时间: 2025年6月25日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-17/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-03/01-T.png'),
    title:"五指山秘境·邂逅野生玉叶金花",
    time:'时间: 2025年6月20日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-03/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-07/01-T.png'),
    title:"华南理工大学冯娴慧教授一行到流溪河国家森林公园调研",
    time:'时间: 2025年6月13日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-07/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-05/01-T.png'),
    title:"保护野生动物，人人有责",
    time:'时间: 2025年6月10日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-05/01.pdf')
},
{
    img: require('@/newsData/list/2025-1001-16/01-T.png'),
    title:"紧急提醒｜景区雨后蘑菇虽美，但千万别碰！这些“毒伞”碰不得",
    time:'时间: 2025年6月10日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-16/01.pdf')
},

{
    img: require('@/newsData/list/2025-1001-09/01-T.png'),
    title:"夏日的“树上荷花”——木荷，邀您共赏自然奇观",
    time:'时间: 2025年05月26日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-09/01.pdf')
},

{
    img: require('@/newsData/list/2025-1001-08/01-T.png'),
    title:"喜报 喜报！广州市流溪河国家森林公园2024年景区案例入选“广东省景区行业高质量发展优秀案例”",
    time:'时间: 2025年5月19日',
    detail:``,
    detail_url: require('@/newsData/list/2025-1001-08/01.pdf')
},
            {
                img: require('@/assets/imgs/all/2025-0516-02-01.png'),
                title:"初夏限定｜尖叶杜英：树梢的白衣仙子，邀你共赏流苏花雨",
                time:'时间: 2025年5月16日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0516-02-02.png')
            },
            {
                img: require('@/assets/imgs/all/2025-0516-01-01.png'),
                title:"“520心形落羽杉”甜蜜上线！广州这片“告白森林”等你来打卡",
                time:'时间: 2025年5月16日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0516-01-02.png')
            },
            {
                img: require('@/assets/imgs/all/2025-0515-01-01.png'),
                title:"流溪河国家森林公园管理中心与农业银行联合开展防诈骗宣传暨便民服务活动",
                time:'时间: 2025年5月15日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0515-01-02.png')
            },
            {
                img: require('@/assets/imgs/all/2025-0512-01-01.png'),
                title:"广州市流溪河国家森林公园管理中心开展“5·12全国防灾减灾日”宣传活动",
                time:'时间: 2025年5月12日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0512-01-02.png')
            },
          {
                img: require('@/assets/imgs/all/2025-0429-01-01.png'),
                title:"流溪河国家森林公园“水趣流溪·夏日初探”主题活动五一启幕 广州亲子玩水新地标邀您畅玩！",
                time:'时间: 2025年4月29日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0429-01-02.png')
            },
            {
                img: require('@/assets/imgs/all/2025-0424-01-01.png'),
                title:"春色撩人，近百年刺毛杜鹃绚烂盛放",
                time:'时间: 2025年4月24日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0424-01-02.png')
            },
            {
                img: require('@/assets/imgs/all/2025-0424-01-01.png'),
                title:"春日“枫”景正盛，邀您共赏红霞漫天",
                time:'时间: 2025年4月24日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0424-01-02.png')
            },
            {
                img: require('@/assets/imgs/all/2025-0423-01-01.png'),
                title:"“青梅竹马”从化农文旅体产业推广活动在流溪河森林公园分会场活动回顾",
                time:'时间: 2025年4月23日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0423-01-02.png')
            },
            {
                img: require('@/assets/imgs/all/2025-0416-01-01.png'),
                title:"鱼跃流溪河 助力“百千万”——2025年保护流溪河渔业增殖放流活动顺利举办",
                time:'时间: 2025年4月16日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0416-01-02.png')
            },
            {
                img: require('@/assets/imgs/all/2025-0411-01-01.png'),
                title:"又见白鹭——《白鹭与生态环境》作品再创佳绩！",
                time:'时间: 2025年4月11日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0429-01-02.png')
            },
            {
                img: require('@/assets/imgs/all/2025-0408-01-01.png'),
                title:"知青重聚流溪河 共叙青春岁月",
                time:'时间: 2025年4月8日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0408-01-02.png')
            },
            {
                img: require('@/assets/imgs/all/2025-0327-01-01.png'),
                title:"保护野生鸟类，共建绿美流溪——广州市流溪河国家森林公园管理中心爱鸟周宣传活动成功举办",
                time:'时间: 2025年3月27日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0327-01-02.png')
            },
          {
                img: require('@/assets/imgs/all/2025-03-27-01-01.png'),
                title:"“禾雀花与毛棉杜鹃撞个满怀",
                time:'时间: 2025年3月27日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-03-27-01-02.png')
            },
            {
                img: require('@/assets/imgs/all/2025-03-11-02-02.png'),
                title:"阳春三月，流溪河国家森林公园喊你来种“熊猫”啦！",
                time:'时间: 2025年3月27日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-03-27-02-02.png')
            },
          {
                img: require('@/assets/imgs/all/2025-03-14-01-01.png'),
                title:"“从化区人大常委会、从化区政协到广州市流溪河国家森林公园调研",
                time:'时间: 2025年3月14日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-03-14-01-02.png')
            },
          {
                img: require('@/assets/imgs/all/2025-03-14-02-01.png'),
                title:"“ 我为全运种棵树 绿美流溪启新程——流溪河国家森林公园管理中心开展义务植树活动",
                time:'时间: 2025年3月14日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-03-14-02-02.png')
            },
          {
                img: require('@/assets/imgs/all/2025-03-11-02-02.png'),
                title:"“奔赴流溪，植绿点亮全运”广州市流溪河国家森林公园植树节报名活动开启啦!",
                time:'时间: 2025年3月11日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-03-11-02-01.png')
            },
          {
                img: require('@/assets/imgs/all/2025-03-11-01-02.png'),
                title:"广州市流溪河国家森林公园野生香港带唇兰惊喜绽放",
                time:'时间: 2025年3月11日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-03-11-01-01.png')
            },
          {
                img: require('@/assets/imgs/all/202502120102.png'),
                title:"活动回顾“踏春游园，樱遇流溪”流溪河国家森林公园春节系列活动圆满举行",
                time:'时间: 2025年2月16日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0212-0101.png')
            },
            {
                img: require('@/assets/imgs/all/202502120201.png'),
                title:"流溪河国家森林公园：玉兰花与樱花共绽 开启早春浪漫之旅",
                time:'时间: 2025年2月16日',
                detail:``,
                detail_url: require('@/assets/imgs/all/2025-0212-0201.png')
            },  
          {
                img: require('@/assets/imgs/all/202501160102.png'),
                title:"广东省林业事务中心副主任黎明带队到流溪河国家森林公园调研自然教育工作",
                time:'时间: 2025年1月9日',
                detail:``,
                detail_url: require('@/assets/imgs/all/202501160101.png')
            },{
                img: require('@/assets/imgs/all/202501160202.png'),
                title:"关爱游客暖人心，贴心服务赢赞誉",
                time:'时间: 2025年1月8日',
                detail:``,
                detail_url: require('@/assets/imgs/all/202501160201.png')
            },
            {
                img: require('@/assets/imgs/all/202501160302.png'),
                title:"流溪河国家森林公园管理中心开展共建交流活动",
                time:'时间: 2025年1月6日',
                detail:``,
                detail_url: require('@/assets/imgs/all/202501160301.png')
            },
            {
                img: require('@/assets/imgs/all/202501160402.png'),
                title:"提升讲解水平，讲好流溪故事——流溪河国家森林公园管理中心开展讲解员培训",
                time:'时间: 2025年1月2日',
                detail:``,
                detail_url: require('@/assets/imgs/all/202501160401.png')
            },  
            {
                img: require('@/assets/imgs/thumbnail/2025010401.png'),
                title:"齐聚流溪赏香雪，共享发展新红利",
                time:'时间: 2025年1月4日',
                detail:``,
                detail_url: require('@/assets/imgs/news/2025010401.png')
            },
            {
                img: require('@/assets/imgs/thumbnail/2024122602.png'),
                title:"广州市流溪河国家森林公园管理中心与旅客合力救助国家二级保护动物领角鸮",
                time:'时间: 2024年12月26日',
                detail:``,
                detail_url: require('@/assets/imgs/news/2024122602.png')
            },
            {
                img: require('@/assets/imgs/thumbnail/2024122601.png'),
                title:"广州市流溪河国家森林公园管理中心开展元旦节森林防火和安全生产检查",
                time:'时间: 2024年12月25日',
                detail:``,
                detail_url: require('@/assets/imgs/news/2024122601.png')
            },
            {
                img: require('@/assets/imgs/thumbnail/2024122001.jpg'),
                title:"【喜讯】流溪河国家森林公园管理中心获评广州市事业单位干部培训现场教学基地",
                time:'时间: 2024年12月25日',
                detail:``,
                detail_url: require('@/assets/imgs/news/2024122001.png')
            },

            {
                img: require('@/assets/imgs/thumbnail/202412250202.png'),
                title:"广州country walk打卡计划",
                time:'时间: 2024年12月25日',
                detail:``,
                detail_url: require('@/assets/imgs/news/2024122502.png')
            },
            {
                img: require('@/assets/imgs/thumbnail/202412250101.png'),
                title:"预热梅花节",
                time:'时间: 2024年12月25日',
                detail:``,
                detail_url: require('@/assets/imgs/news/2024122501.png')
            },
            {
                img: require('@/assets/imgs/thumbnail/202412240101.jpeg'),
                title:"广建园林杯流溪河国家森林公园全国诗词联赋大赛评审结果公告",
                time:'时间: 2024年12月24日',
                detail:``,
                detail_url: require('@/assets/imgs/news/2024122401.jpg')
            },
            {
                img: require('@/assets/imgs/thumbnail/202412180101.png'),
                title:"广州市流溪河国家森林公园管理中心开展森林防火“双盲”应急演练",
                time:'时间: 2024年12月18日',
                detail:`12月18日，广州市流溪河国家森林公园管理中心开展森林防火“双盲”应急演练`,
                detail_url: require('@/assets/imgs/news/2024121801.png')
            },
            {
                img: require('@/assets/imgs/thumbnail/202412100101.png'),
                title:"从化区委常委朱秀英到流溪河林场调研",
                time:'时间: 2024年12月6日',
                detail:`12月6日，从化区委常委朱秀英到流溪河林场调研公共安全等相关工作`,
                detail_url: require('@/assets/imgs/news/2024121001.png')
            },
            {
                img: require('@/assets/imgs/thumbnail/202412100303.png'),
                title:"2024年宪法宣传周——“大力弘扬宪法精神 推动进一步全面深化改革”",
                time:'时间: 2024年12月4日',
                detail:`2024年宪法宣传周宪法宣传视频`,
                detail_url: require('@/assets/media/20241210.mp4'),
            },
            {
                img: require('@/assets/imgs/thumbnail/202412100202.png'),
                title:"广州市流溪河国家森林公园管理中心开展宪法普法暨新修订《保密法》专题讲座",
                time:'时间: 2024年12月4日',
                detail:`12月4日，广州市流溪河国家森林公园管理中心开展宪法普法暨新修订《保密法》专题讲座`,
                detail_url: require('@/assets/imgs/news/2024121002.png')
            },
            {
                img: require('@/assets/imgs/thumbnail/2024120501.png'),
                title:"驻良口镇帮镇扶村工作队到流溪河国家森林公园调研交流",
                time:'时间: 2024年11月26日',
                detail:`11月26日，驻良口镇帮镇扶村工作队到流溪河国家森林公园调研，并就“百千万工程”建设、绿美广州生态建设等方面进行交流。`,
                detail_url: require('@/assets/imgs/news/20241205.png')
            },
            {
                img: require('@/assets/imgs/thumbnail/202411290202.png'),
                title:"活动回顾|广雅中学花都学院徒步流溪拾秋研学教育",
                time:'时间: 2024年11月15日',
                detail:`在11月15日，广雅中学花都学院初中部初二年级学生到广州市流溪河国家森林公园开展徒步流溪拾秋研学动植奥秘活动`,
                detail_url: require('@/assets/imgs/news/2024112902.png')
            },
            {
                img: require('@/assets/imgs/thumbnail/202411290101.png'),
                title:"中国体育彩票2024年流溪河国家森林公园首届体育文化（旅游节）—徒步活动助力“百千万工程”共建绿美广州活动隆重举行！",
                time:'时间: 2024年11月9日',
                detail:`2024年流溪河国家森林公园首届体育文化（旅游节）—徒步活动于11月9日举行。本次活动由广州市流溪河林场主办，中国体育彩票管理中心、广州体育总会、广州市体育局承办，旨在通过“百千万工程”共建绿美广州活动，为广州市打造生态宜居城市贡献力量。`,
                detail_url: require('@/assets/imgs/news/2024112901.png')
            },
            {
                img: require('@/assets/imgs/thumbnail/202411290303.png'),
                title:"绿动流溪 水润万物——第十三届广州儿童生态环境实践活动（第二场）圆满举办",
                time:'时间: 2024年11月3日',
                detail:`由广州市儿童活动中心主办的第十三届广州儿童生态实践活动——“绿动流溪 水润万物”圆满举办。20余组亲子家庭齐聚广州市流溪河国家森林公园，共同体验了一场研学之旅。`,
                detail_url: require('@/assets/imgs/news/2024112903.png')
            },
            {
                img: require('@/assets/imgs/thumbnail/202411290404.png'),
                title:"中国体育彩票-广州市流溪河国家森林公园首届赛艇季暨环湖徒步嘉年华开幕啦！",
                time:'时间: 2024年11月2日',
                detail:`11月2日，由广州市体育局、广州市林业和园林局、从化区“百千万工程”指挥部办公室指导，从化区文化广电旅游体育局与广州市流溪河国家森林公园管理中心联合主办的“中国体育彩票-广州市流溪河国家森林公园首届赛艇季暨环湖徒步嘉年华”在广州市流溪河国家森林公园流溪湖景区隆重开幕。`,
                detail_url: require('@/assets/imgs/news/2024112904.png')
            },
//               {
//                 img:'https://hi.cxtrip.cc/cxyTicket/lxh/xinwen/xinwen4.png',
//                 title:'广州市流溪河林场更新单元详细规划社会稳定风险评估公众参与信息公示',
//                 time:'时间: 2023年7月24日',
//                 detail:`根据《国家发展改革委关于印发重大固定资产投资项目社会稳定风险评估暂行办法的通知》（发改投资[2012]2492号）、《广东省发展改革委重大项目社会稳定风险评估暂行办法》（粤发改重点[2012]1095 号）等文件的要求，现对《广州市流溪河林场更新单元详细规划》信息进行公示，征询该调整事项社会稳定风险的意见和建议。
// `,    
//                 firstPart:`一、项目概况
//                             （一）规划范围
//                 流溪河国家森林公园是位于广东省广州市从化区的生态型公园，公园总面积8932.31公顷。流溪河林场更新详细规划审查专项所涉及的规划范围为流溪河国家森林公园(除东星村、谷星村、温塘肚村)，总面积约6819.50公顷。其中城市更新单元范围暂按初步成果中划定的单元面积295公顷计算。最终上报范围以广州市城乡规划和自然资源主管部门指导为准。
//                 （二）规划定位
//                 由工区向小镇转变，游览式向参与式转变单一游览功能向综合提升造血能力转变，定位为珠三角北部生态涵养地、羊城最洁水源地、南亚热带森林天堂广州市生态文明教育示范基地、自然课堂国家森林特色小镇以森林体验和森林养生为主的“绿色养生谷森林康养第一镇、国际森林康养基地国家AAAA级旅游景区。
//                 （三）功能定位
//                 “森林+森林旅游”：森林生态观光、森林拓展训练、森林露营体验、森林休憩娱乐
//                 “森林+森林康养”：森林体育康养、森林养老康养、森林医疗康养、森林教育康养
//                 “森林+自然教育”：森林研学教育、自然文化科普、文化艺术交流、爱国文化教育
//                 “森林+林下经济”：药材、林果茶叶种植、高端养殖、野生采摘、农产品加工
//                 （四）规划结构
//                 规划“三个单元、四类分区”，“三个单元”为北部生态单元、森林康养小镇城镇建设单元、五指山生态单元；“四个分区”为森林旅游区、森林康养区、自科教育区、生态保育区。
//                 三个单元、四类分区`,
//                 secPart:`
//                 二、社会稳定风险的评估工作程序和工作内容
//                 1、对项目风险调查、风险识别的过程和方式方法进行评估。
//                 2、对项目建设的合理性、合法性、可行性和可控性进行评估。
//                 3、对项目可能导致社会稳定风险产生的因素进行评估。
//                 4、对项目的社会稳定风险进行评级，提出改进措施或项目实施建议。`,
//                 thrPart:`三、征求公众意见的主要范围及事项
//                 1、项目对当地社会及经济发展的影响；
//                 2、项目对公民个人或家庭自身利益的影响；
//                 3、项目可能产生的安全因素与自身利益的影响；
//                 4、项目可能产生的环境因素与自身利益的影响；
//                 5、对本项目的态度；
//                 6、公众关心的其他相关问题。`,
//                 fourPart:`四、公示说明
//                 1、公示时间：2023年7月24日—2023年7月30日止，共7天。
//                 2、公示期间，如对本项目有社会稳定风险方面的意见或建议，可通过电话、电子邮件向评估单位提出。`,
//                 fivePart:`五、联系方式
//                 评估单位：重庆交通大学工程设计研究院有限公司
//                 联 系 人：黄小姐        联系电话：13809241014
//                 邮 箱：huangdingyi2021@163.com
//                 您的意见和建议对本项目具有积极作用，我们在此对您表示真挚的感谢！`,
//                 detail_url: require('@/assets/imgs/news/2024112901.png')
//               },
//               {
//               img:'https://hi.cxtrip.cc/cxyTicket/lxh/xinwen/xinwen2.jpg',
//               title:'从化区副区长廖绮晶到流溪河林场督导检查水上交通安全生产工作',
//               time:'时间: 2023年6月7日',
//               detail:`6月7日上午，从化区副区长廖绮晶带队到流溪河林场督导检查水上交通安全生产工作。从化区府办、区交通运输局、区公安分局、区应急管理局、区消防大队、区农业农村局、区文广旅体局、良口镇政府、流溪河林场相关负责同志陪同。
// 廖绮晶副区长仔细听取了流溪河林场水上交通安全治理工作开展情况汇报，并检查了工作台帐，随后到流溪河水库进行实地检查。廖绮晶副区长充分肯定了流溪河林场水上交通安全治理工作，并提出了三点工作要求：一是各相关责任部门单位要切实提高思想认识和政治站位，认真贯彻执行人民至上，生命至上的安全生产发展理念；二是各部门单位按职责分工，各司其职，形成合力，齐抓共管，强化风险隐患排查，加强宣传和库区巡查；三是采取有效措施，开展水上安全联合整治行动，共同打击水上违法行为，消除水上各类风险隐患，确保人民群众生命财产安全，促进流溪河水库水上交通安全形势向好发展。
// `
//           },
        //   {
        //     img:'https://hi.cxtrip.cc/cxyTicket/lxh/xinwen/xinwen1.jpg',
        //       title:'市林业园林局党组书记、局长蔡胜到流溪河国家森林公园管理中心调研',
        //       time:'时间: 2023年5月28日',
        //       detail:`5月28日，市林业园林局党组书记、局长蔡胜到流溪河国家森林公园管理中心走访调研。市林业园林局总工程师粟娟，办公室、营造林管理处和服务监督处有关负责同志及流溪河国家森林公园管理中心党政主要负责同志陪同。蔡胜局长听取了管理中心关于绿美广州生态建设、信访维稳、安全生产等工作的情况汇报，随后提出了七点工作意见：一是深入学习领会习近平总书记重要讲话精神，认真贯彻党中央关于开展主题教育的部署要求，以高度政治责任感和求真务实作风，推动主题教育不断向纵深发展；二是始终紧绷安全生产这根弦，强化责任意识、全面排查隐患、抓好重点区域、夯实安全基础，有效防范遏制各类生产安全事故发生；三是严格落实“三防”责任制和24小时值班值守制度，强化巡查监控，密切关注汛情，确保安全度汛；四是深入推进绿美广州生态建设，以“护水、连山、串景、融育”为主线奋力打造绿美广州生态建设北部示范点，为广州市实现老城市新活力、“四个出新出彩”增添生态底色；五是以满足人民日益增长的美好生活需要为出发点和落脚点，继续紧抓电网改造移交、天然气管网建设、供水改造等民生实事，用心用情解决群众急难愁盼的历史遗留问题，把发展成果不断转化为生活品质，不断提升人民群众获得感、幸福感、安全感；六是以群众需求为导向，通过自然教育基地和森林康养基地建设加快推进森林公园建设的步伐，精心塑造多色彩特色森林景观，开放公园绿地草坪，拉近生态文明建设和群众日常生活之间的距离，真正让群众共享生态文明建设成果；七是要树牢以人民为中心的发展思想，畅通和规范群众诉求表达通道，依法依规、公平公正解决群众合理诉求，把矛盾纠纷处理在初发阶段、化解在萌芽状态，为高质量发展营造和谐稳定的社会环境。`
        //   },
//           {
//             img:'https://hi.cxtrip.cc/cxyTicket/lxh/xinwen/xinwen3.jpg',
//             title:'市林业园林局一级调研员（市管）梁湛涛到流溪河国家森林公园管理中心调研',
//             time:'时间: 2023年5月25日',
//             detail:`5月25日，市林业园林局一级调研员（市管）梁湛涛到流溪河国家森林公园管理中心调研。市林业园林局服务监督处，流溪河国家森林公园管理中心领导陪同。
// 梁湛涛同志一行到森林公园景区了解草坪开放情况，随后听取了管理中心近期信访工作的汇报。梁湛涛同志对管理中心工作提出了三点意见：一是要做好公园草坪开放准备工作，落实厕所、垃圾桶、水电等基本配套设施建设，更好地满足游客亲近自然、休闲游憩的需求；二是要始终把安全生产摆在工作的重中之重，持续深入开展安全隐患排查整治，牢牢守住安全生产底线，坚决遏制各类事故发生；三是要常态长效推进信访问题源头治理和信访积案化解，及时了解问题、破解难题，真正把矛盾纠纷化解在基层、解决在当地，切实维护社会大局和谐稳定。
// `}
        ]
}